import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const MailIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="31.5" height="23.674" viewBox="0 0 31.5 23.674">
      <svg width="65" height="46" viewBox="0 0 65 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_168_7)">
          <path
            d="M56.75 43.85H7.29001C4.37001 43.85 2.01001 41.48 2.01001 38.55V7.3C2.01001 4.38 4.38001 2 7.29001 2H56.75C59.67 2 62.03 4.37 62.03 7.3V38.55C62.03 41.47 59.66 43.84 56.75 43.84V43.85Z"
            stroke="#003939"
            stroke-width="4.01"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.12 12.14L31.95 27.89L53.92 12.14"
            stroke="#32B88E"
            stroke-width="4"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_168_7">
            <rect width="64.04" height="45.85" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};
